import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CloudExtractLoadService } from '../cloud-extract-load.service';

@Component({
  selector: 'app-load-to-cloud',
  templateUrl: './load-to-cloud.component.html',
  styleUrls: ['./load-to-cloud.component.scss']
})
export class LoadToCloudComponent implements OnInit {
  options: any;
  title: string;
  selectTab: string ;
  // submitTab: boolean = true;
  // loadTab: boolean = true;
  public itemNumber = 0;
  public progressBarName = 'select';
  public progressBarArray1: any = [
    { name: "select", src: 'assets/select.png', index: 0 },
    { name: "submit", src: 'assets/submit.png', index: 1 },
    { name: "upload", src: 'assets/disabled_upload.png', index: 2 },
    { name: "load", src: 'assets/icon_cloud load.png', index: 3 }
  ];
  constructor(private celService : CloudExtractLoadService,
    private router: Router,private route: ActivatedRoute) { }

  ngOnInit(): void {
    let sessionData = sessionStorage.getItem("key");
    sessionStorage.removeItem("key");
    if(sessionData != null){
      sessionData = JSON.parse(sessionData);
      if(sessionData[1] === 'select'){
        this.title = 'Load Transformed To Cloud';
        this.itemNumber = 0;
        this.progressBarName = 'select';
        this.celService.extractBatchKey = sessionData[0];
        this.celService.tabval.next('select');
        this.router.navigate(['select'],{ relativeTo: this.route });

      }
    }
    this.options = this.celService.options;
    if(this.options == null){
      this.celService.tabval.subscribe(res => {
        this.selectTab = res;
        if (res === 'select') {
          this.title = 'Load Transformed To Cloud';
          this.itemNumber = 0;
          this.progressBarName = 'select';
          this.router.navigate(['select'], { relativeTo: this.route });
        } else if(res === 'submit'){
          this.itemNumber = 1;
          this.progressBarName = 'submit';
          this.progressBarArray1[0].src = 'assets/complete.png';
          this.progressBarArray1[1].src = 'assets/submit.png';
          this.progressBarArray1[2].src = 'assets/disabled_upload.png';
          this.title = 'Submit Batch ';
          this.router.navigate(['submit'],{ relativeTo: this.route });
        }else if(res === 'load'){
          this.itemNumber = 3;
          this.progressBarName = 'load';
          this.progressBarArray1[0].src = 'assets/complete.png';
          this.progressBarArray1[1].src = 'assets/complete.png';
          this.progressBarArray1[2].src = 'assets/complete.png';
          this.title = 'Load Batch to Cloud';
          this.router.navigate(['load'],{ relativeTo: this.route });
        }else if(res === 'upload'){
          this.itemNumber = 2;
          this.progressBarName = 'upload';
          this.title = 'Upload Batch to Cloud';
          this.progressBarArray1[0].src = 'assets/complete.png';
          this.progressBarArray1[1].src = 'assets/complete.png';
          this.progressBarArray1[2].src = 'assets/active_upload.png';
          this.router.navigate(['upload'],{ relativeTo: this.route });
        }
      });
    }else{
    // this.setTitle(this.options.status);
    this.celService.tabval.subscribe(res => {
      this.selectTab = res;
      if(res === 'select'){
          this.title = 'Load Transformed To Cloud';
          this.itemNumber = 0;
          this.progressBarName = 'select';
          this.router.navigate(['select'],{ relativeTo: this.route });
      }else if(res === 'submit'){
        this.itemNumber = 1;
        this.progressBarName = 'submit';
        this.title = 'Submit Batch ';
        this.progressBarArray1[0].src = 'assets/complete.png';
        this.progressBarArray1[1].src = 'assets/submit.png';
        this.progressBarArray1[2].src = 'assets/disabled_upload.png';
        this.router.navigate(['submit'],{ relativeTo: this.route });
      }else if(res === 'load'){
        this.itemNumber = 3;
        this.progressBarName = 'load';
        this.title = 'Load Batch to Cloud';
        this.progressBarArray1[0].src = 'assets/complete.png';
        this.progressBarArray1[1].src = 'assets/complete.png';
        this.progressBarArray1[2].src = 'assets/complete.png';
        this.router.navigate(['load'],{ relativeTo: this.route });
      }else if(res === 'upload'){
        this.itemNumber = 2;
        this.progressBarName = 'upload';
        this.title = 'Upload Batch to Cloud';
        this.progressBarArray1[0].src = 'assets/complete.png';
        this.progressBarArray1[1].src = 'assets/complete.png';
        this.progressBarArray1[2].src = 'assets/active_upload.png';
        this.router.navigate(['upload'],{ relativeTo: this.route });
      }
    });
  }
  }

  setTitle(status){
    switch (status) {
      case 'Transformed':
        this.celService.tabval.next('load');
        this.router.navigate(['load'],{ relativeTo: this.route });
        break;
        case 'New':
        this.celService.tabval.next('select');
        this.router.navigate(['select'],{ relativeTo: this.route });
        break;
        default:this.title = '';
        break;
    }
  }





}
